// extracted by mini-css-extract-plugin
export default {"container":"basic-info_container__+n-Rg","card-container":"basic-info_card-container__C6I1S"};